const banner = document.querySelector('.banner');

class BannerHandler {
    constructor(element) {
        this.element = element
        this.closeButton = this.element.querySelector('.action-close')

        this.initBanner()
        this.closeHandler()
    }

    initBanner() {
        const isBannerClosed = sessionStorage.getItem('isBannerClosed')
        if (!isBannerClosed) {
            this.element.classList.toggle('banner--hidden')
        }
    }

    closeHandler() {
        this.closeButton.addEventListener('click', event => {
            event.preventDefault()
            this.element.classList.toggle('banner--hidden')
            sessionStorage.setItem('isBannerClosed', 1)
        })
    }
}

new BannerHandler(banner)